import { FunctionComponent } from "react";
import styles from "./button.module.scss";

const Button: FunctionComponent<{
  children?: any;
  className?: string;
  onClick: () => void;
}> = ({ children = null, className = "", onClick }) => {
  return (
    <button className={`${className} ${styles.button}`} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
